package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.BackgroundClip
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.POPPINS
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val BlueGradientTextStyle = CssStyle {
    base {
        Modifier
             .backgroundImage(
              gradient = linearGradient(
                  from = Colors.DarkBlue,
                  to = Colors.linear,
                  dir = LinearGradient.Direction.ToRight
            )
        )
            .background { clip(BackgroundClip.Text) }
            .color(Color.transparent)
    }
}

val MyStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.linear)
            .color(Colors.White)
            .border(0.px, LineStyle.Solid, Colors.White)
            .styleModifier {
                property("appearance", "none")
                property("-webkit-appearance", "none")
                property("background-image", "none")
                property("cursor", "pointer")
                property("transition", "all 0.3s ease")
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.linear)
            .color(Colors.White)
            .border(2.px, LineStyle.Solid, Colors.White)
    }
}

val ProcedureImageStyle = CssStyle {
    base {
        Modifier
            .height(90.px)
            .objectFit(ObjectFit.Cover)
            .boxShadow(color = Color.transparent)
            .transition {
                duration(800.ms)
                timingFunction(TransitionTimingFunction.cubicBezier(0.2, 1.20, 0.2, 1.0))
            }
    }
    Breakpoint.SM { Modifier.height(130.px) }
    Breakpoint.MD { Modifier.height(150.px) }
    Breakpoint.LG { Modifier.height(220.px) }
    Breakpoint.XL { Modifier.height(310.px) }

    hover {
        Modifier
            .scale(1.15)
            .styleModifier {
                property("filter", "blur(0.3px)")
            }
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 6.px,
                spreadRadius = 3.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}

val CreateCardStyle = CssStyle {

    base {
        Modifier
            .border {
                width(1.5.px)
                style(LineStyle.Dashed)
                color(Colors.GrayLight)
            }
            .color(Colors.Graytext)
            .transition {
                duration(250.ms)
            }
    }

    hover {
        Modifier
            .border {
                width(1.5.px)
                style(LineStyle.Dashed)
                color(Colors.lightblue)
            }
            .color(Colors.lightblue)
    }
}

val newbuttonStyle = CssStyle {

    base {
        Modifier
            .backgroundColor(Colors.NightBlue)
            .color(Colors.DarkGray)
            .border(width = 1.px, style = LineStyle.Solid, color = Colors.DarkGray)
    }

    hover {
        Modifier
            .backgroundColor(Colors.White)
            .color(Colors.NightBlue)
            .border(width = 1.px, style = LineStyle.Solid, color = Colors.DarkGray)
    }
}
val ProcedureSectionStyle = CssStyle {
    // Base = Mobile (isMobile)
    base {
        Modifier.padding(
            top = 30.px,
            bottom = 20.px,
            leftRight = 15.px
        )
    }

    // MD / LG = Tablette (isTablet -> Breakpoint.LG dans ton code initial)
    Breakpoint.MD {
        Modifier.padding(
            top = 100.px,
            bottom = 60.px,
            leftRight = 60.px
        )
    }

    // XL = Desktop (else -> 200.px)
    Breakpoint.XL {
        Modifier.padding(
            top = 100.px,
            bottom = 60.px,
            leftRight = 200.px // conserve top et bottom !
        )
    }
}
val ProcedureTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(30.px)
            .fontFamily(POPPINS)
            .fontWeight(FontWeight.Bold)
    }

    Breakpoint.LG {
        Modifier.fontSize(50.px)
    }
}

val ProcedureTitleContainerStyle = CssStyle {
    base {
        Modifier.padding(bottom = 20.px)
    }

    Breakpoint.LG {
        Modifier.padding(bottom = 40.px)
    }
}

val ProcedureSpacerStyle = CssStyle {
    base {
        Modifier.height(15.px)
    }

    Breakpoint.LG {
        Modifier.height(40.px)
    }
}

//conteneur stepcard
val StepCardStyle = CssStyle {
    base {
        Modifier
            .width(100.px)
            .height(100.px)
//            .padding(top = 20.px)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = Colors.bluelight
            )
            .borderRadius(12.px)
            .padding(
                top = 20.px,
                bottom = 10.px,
                left = 6.px,
                right = 6.px
            )
    }

    Breakpoint.LG {
        Modifier
            .width(252.px)
            .height(165.px)
            .borderRadius(22.px)
            .padding(
                top = 45.px,
                bottom = 25.px,
                left = 15.px,
                right = 15.px
            )
    }
}
val StepTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(8.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Normal)
            .textAlign(TextAlign.Center)
            .whiteSpace(WhiteSpace.PreWrap)
    }

    Breakpoint.LG {
        Modifier.fontSize(16.px)
    }
}
val StepNumberStyle = CssStyle {
    base {
        Modifier
            .fontSize(20.px)
            .fontFamily(POPPINS)
            .fontWeight(FontWeight.Bold)
            .color(Colors.bluelight)
    }

    Breakpoint.LG {
        Modifier.fontSize(50.px)
    }
}

//image preview
val ImagesPreviewSectionStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .margin(top = 5.px)
            .padding(leftRight = 8.px)
            .gap(8.px)
    }

    Breakpoint.LG {
        Modifier
            .padding(leftRight = 5.px)
            .gap(40.px)
    }
}
//        verticalAlignment = Alignment.CenterVertically
val ProcedureArrowStyle = CssStyle {
    base {
        Modifier
            .width(45.px)
            .height(40.px)
            .margin(leftRight = 2.px)
    }

    Breakpoint.LG {
        Modifier
            .width(140.px)
            .height(120.px)
            .margin(leftRight = 5.px)
    }
}
val StepBadgeStyle = CssStyle {
    base {
        // Mobile par défaut
        Modifier
            .width(30.px)
            .top((-40).px)
            .margin(right = 15.px, left = 10.px)
            .border(width = 1.px, style = LineStyle.Solid, color = Colors.bluelight)
            .borderRadius(6.px)
            .padding(topBottom = 2.px, leftRight = 6.px)
    }
    Breakpoint.MD {
        // Desktop / Tablette
        Modifier
            .width(62.px)
            .top((-90).px)
            .borderRadius(10.px)
            .padding(topBottom = 5.px, leftRight = 15.px)
    }
}